import { useCallback, useState } from 'react';
import { useAuth } from '@/state/auth/AuthContext.jsx';
import { SCAN_COMPROBANTE_COBRANZA } from '@/graphql/mutations/scanComprobanteCobranza.gql.js';

const GRAPHQL_ENDPOINT = `${import.meta.env.VITE_API_URL || 'https://api.sinamonsoft.ar'}/graphql`;

export function useComprobanteScan() {
  const { token, tenant } = useAuth();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const reset = useCallback(() => {
    setResult(null);
    setError('');
  }, []);

  const scan = useCallback(
    async ({ file, sucursalId }) => {
      if (!file) {
        setError('Seleccioná un archivo para analizar.');
        return null;
      }
      setLoading(true);
      setError('');
      setResult(null);
      try {
        const operations = {
          query: SCAN_COMPROBANTE_COBRANZA,
          variables: {
            file: null,
            sucursalId,
          },
        };
        const map = { 0: ['variables.file'] };
        const formData = new FormData();
        formData.append('operations', JSON.stringify(operations));
        formData.append('map', JSON.stringify(map));
        formData.append('0', file);

        const response = await fetch(GRAPHQL_ENDPOINT, {
          method: 'POST',
          headers: {
            ...(tenant?.code ? { 'X-Tenant': tenant.code } : {}),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: formData,
        });

        const payload = await response.json();
        if (payload.errors?.length) {
          throw new Error(payload.errors[0]?.message || 'No se pudo analizar el comprobante.');
        }
        const data = payload.data?.scanComprobanteCobranza || null;
        if (import.meta.env.DEV) {
          console.debug('[ComprobanteScan] Resultado:', data);
        }
        setResult(data);
        return data;
      } catch (err) {
        const message = err?.message || 'No se pudo analizar el comprobante.';
        setError(message);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [tenant?.code, token],
  );

  return {
    loading,
    result,
    error,
    scan,
    reset,
  };
}
